import React from 'react'
import { Query } from 'react-apollo'
import assetsQuery from './assets.graphql'

export default ({ children, variables, ...rest }) => (
  <Query query={assetsQuery} variables={variables}>
    {data => children({ ...data, ...rest })}
  </Query>
)
